/**
 * Basics for dropdown select elements
 * Extend constructor to add the options.
 */
import { html, render, nothing } from "lit-html";
import { repeat } from "lit-html/directives/repeat.js";

class Dropdown extends HTMLElement {
	constructor() {
		super();
		this.options = new Map();
		this.selectedValue = undefined;
		this.classList.add("esc-dropdown");
	}

	connectedCallback() {
		this.render();
	}

	render() {
		render(this.getTemplate(), this, { host: this });
	}

	getTemplate() {
		return html`
			<button
				class="esc-dropdown__button"
				aria-haspopup="menu"
				@click=${this.toggle}
			>
				${this.options.get(this.selectedValue).buttonLabel}<span
					role="presentation"
					class="esc-dropdown__arrow fa fa-angle-down"
				></span>
			</button>
			${this.getAddon()}
			<ul role="menu" class="esc-dropdown__popup">
				${repeat(
					this.options.entries(),
					([value, option]) => html`
						<li
							role="menuitem"
							class="esc-dropdown__option esc-dropdown__option_${value} ${value ==
							this.selectedValue
								? " esc-dropdown__option--selected"
								: ""}"
							@click="${() => this.setValue(value)}"
						>
							${option.listLabel}<span
								role="presentation"
								class="esc-dropdown__check fa fa-check"
							></span>
						</li>
					`,
				)}
			</ul>
		`;
	}

	getAddon() {
		return nothing;
	}

	addOption(value, buttonLabel, listLabel, selected = false) {
		this.options.set(value, {
			buttonLabel,
			listLabel,
		});
		if (this.selectedValue === undefined || selected) {
			this.selectedValue = value;
		}
	}

	toggle(event) {
		event.preventDefault();

		if (this.isOpen()) {
			this.close();
		} else {
			this.open();
		}
	}

	setValue(value) {
		this.selectedValue = value;
		this.render();
		this.close();
	}

	open() {
		if (!this.elsewhereClickHandler) {
			this.elsewhereClickHandler = event => {
				let element = event.target;
				while (element) {
					if (element == this) {
						return;
					}
					element = element.parentElement;
				}
				this.close();
			};
			document.addEventListener("click", this.elsewhereClickHandler);
		}
		this.classList.add("esc-dropdown--open");
	}

	close() {
		if (this.elsewhereClickHandler) {
			document.removeEventListener("click", this.elsewhereClickHandler);
			this.elsewhereClickHandler = null;
		}
		this.classList.remove("esc-dropdown--open");
	}

	isOpen() {
		return this.classList.contains("esc-dropdown--open");
	}
}

export default Dropdown;
